import React from "react";
import { Link } from "react-router-dom";
import { AiOutlineArrowRight, AiOutlineDownload } from "react-icons/ai";
import portrait from "../../Assets/home-main.png";
import pdf from "../../Assets/dharmikresume.pdf";
import { profile, intro } from "../../data/content";

function Hero() {
  return (
    <section className="hero">
      <div className="container hero__inner">
        <div className="hero__text">
          <p className="hero__greeting">
            {profile.greeting}
            <span className="hero__wave" role="img" aria-label="waving hand">
              👋🏻
            </span>
          </p>

          <h1 className="hero__title">
            <span className="hero__title-pre">I'm</span>
            {profile.name}
          </h1>

          <p className="hero__roles">
            {profile.roles.map((role) => (
              <span className="hero__role" key={role}>
                {role}
              </span>
            ))}
          </p>

          <p className="lede hero__lede">{intro.lead}</p>

          <div className="btn-row hero__actions">
            <Link to="/work" className="btn btn--primary">
              View work <AiOutlineArrowRight />
            </Link>
            <a
              href={pdf}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--ghost"
            >
              <AiOutlineDownload /> Download CV
            </a>
          </div>
        </div>

        <div className="hero__portrait">
          <img src={portrait} alt="Dharmik Batra" />
        </div>
      </div>
    </section>
  );
}

export default Hero;
